import React, { Component } from 'react';
import { MODAL_ADD_DASHBOARD } from '../../util/enums/EnumModals';
import {
  DAILY,
  HOURLY,
  MANUAL,
} from '../../util/enums/EnumDashboardRefreshFrequency';
import SelectHour from '../SelectHour';
import { FIVE_MIN } from './ModalAddAlert';
import { NEW_DASHBOARD_NAME_INPUT } from '../../constants/test-ids';

const SCHEDULE_FREQUENCY_OPTIONS = [MANUAL, DAILY, HOURLY];

class ModalAddDashboard extends Component {
  constructor(props) {
    super(props);
    this.setTime = this.setTime.bind(this);
  }

  static modalType() {
    return MODAL_ADD_DASHBOARD;
  }

  static reducer(modals) {
    return modals.addDashboardModal;
  }

  static title() {
    return (
      <span>
        <img src="/img/dashboards-icon.png" className="modal-top-icon" />
        Set up dashboard
      </span>
    );
  }

  componentDidMount() {
    this.takeFocus();
  }

  takeFocus() {
    setTimeout(() => {
      if (this._input) {
        this._input.select();
      }
    }, 500);
  }

  setTime(newTime) {
    const props = { section: 'timeChanged', newValue: newTime };
    this.props.userInteraction(props)();
  }

  render() {
    const {
      state,
      userInteraction,
      isFreePlan,
      isLite,
      isBusiness,
      canRefreshEvery5Minutes,
    } = this.props;

    const onNameChange = (e) => {
      const props = { section: 'nameChanged', newValue: e.target.value };
      userInteraction(props)();
    };

    const onScheduleChange = (e) => {
      const props = {
        section: 'changeSchedule',
        newValue: e.currentTarget.value,
      };
      userInteraction(props)();
    };

    const scheduleFrequencyOptions = canRefreshEvery5Minutes
      ? SCHEDULE_FREQUENCY_OPTIONS.concat(FIVE_MIN)
      : SCHEDULE_FREQUENCY_OPTIONS;

    const scheduleOptions = scheduleFrequencyOptions.map((s) => {
      const isDisabledOption = s === HOURLY && (isFreePlan || isLite);
      const isDisabledOptionBusiness = s === FIVE_MIN && !isBusiness;

      const value = isDisabledOption
        ? `${s} (upgrade to Pro)`
        : isDisabledOptionBusiness
        ? `${s} (upgrade to Trevor Business)`
        : s;

      return (
        <option
          disabled={isDisabledOption || isDisabledOptionBusiness}
          key={`refresh_${s}`}
          value={s.replaceAll(' ', '_')}
        >
          {value}
        </option>
      );
    });

    return (
      <div className="">
        <div className="margin-bottom-20">
          <p className="margin-bottom-10">
            <b>Name your dashboard</b>
          </p>
          <input
            placeholder=""
            data-testid={NEW_DASHBOARD_NAME_INPUT}
            className="form-control set-input-height"
            onChange={onNameChange}
            value={state.name}
            ref={(input) => (this._input = input)}
          />
        </div>
        <div className="margin-bottom-20">
          <p className="margin-bottom-10">
            <b>Refresh schedule</b>
          </p>
          <select
            value={state.schedule}
            className="form-control set-input-height select-schedule"
            onChange={onScheduleChange}
          >
            {scheduleOptions}
          </select>
        </div>
        {state.schedule !== DAILY ? null : (
          <div className="margin-bottom-20">
            <p className="margin-bottom-10">
              <b>Refresh daily at:</b>
            </p>
            <SelectHour chosenTime={state.time} onChange={this.setTime} />
          </div>
        )}
      </div>
    );
  }
}

export default ModalAddDashboard;
